<template>
    <div class="law">
        <h2 class="title is-4" style="text-align:center;">特定商取引法に基づく表記</h2>
        <h3 class="title is-5">事業者</h3>
            <p>雨のネコ社</p>
            <p>加藤  登</p>
        <h3 class="title is-5">連絡先</h3>
            <p>メールアドレス: amenonekosya@gmail.com</p>
        <h3 class="title is-5">返品・交換・キャンセル等</h3>
            <p>商品の特性上、お申し込み後のキャンセルはお受けかねます。予めご了承お願いいたします。</p>
        <h3 class="title is-5">お支払い方法</h3>
            <p>クレジットカード</p>
    </div>
</template>

<script>
export default {
    head: {
        meta:[
            {name:"robots", content:"noindex" }
        ]
    },
    mounted(){
        const title = "特定商取引法に基づく表記｜エモーションダイアリー"
        const description = "特定商取引法に基づく表記のページ"
        document.title = title
        document.querySelector("meta[property='og:title']").setAttribute('content', title)
        document.querySelector("meta[name='description']").setAttribute('content', description)
        document.querySelector("meta[property='og:description']").setAttribute('content', description)
    } 

}
</script>


<style scoped>
.law{
    max-width: 800px;
    margin:auto;
    padding:20px;
}
.title{
    margin-top:40px;
}
</style>
